import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "@/layouts/MainLayout";
import Dashboard from "@/pages/Dashboard";
import LibraryPage from "@/pages/LibraryPage";
import VoyagesList from "@/pages/VoyagesList";
import VoyageNew from "@/pages/VoyageNew";
import VoyageDetail from "@/pages/VoyageDetail";
// Phase 16 (F7/CO2) — Quick Picker grid view route.
import QuickPicker from "@/pages/QuickPicker";
import PdfLayoutSettings from "@/pages/PdfLayoutSettings";
import BackupRestore from "@/pages/BackupRestore";
import PrintStations from "@/pages/PrintStations";
import ShipSettingsPanel from "@/components/ShipSettingsPanel";
import AccessGate from "@/components/AccessGate";

function App() {
  return (
    <AccessGate>
      <BrowserRouter>
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<Navigate to="/voyages" replace />} />
          <Route path="/voyages" element={<VoyagesList />} />
          <Route path="/voyages/new" element={<VoyageNew />} />
          <Route path="/voyages/:id" element={<VoyageDetail />} />
          {/* Phase 16 (F7/CO2) — Quick Picker grid page. */}
          <Route path="/voyages/:id/quick-picker" element={<QuickPicker />} />
          <Route path="/dashboard" element={<Dashboard />} />
          {/* Phase 8 — PDF layout customization (section colours + ordering). */}
          <Route path="/settings/pdf-layout" element={<PdfLayoutSettings />} />
          {/* Phase 10 — Backup & Restore. */}
          <Route path="/settings/backup" element={<BackupRestore />} />
          {/* Phase 11 — Print Stations (multi-library PDF handout). */}
          <Route path="/print/stations" element={<PrintStations />} />
          {/* Ships used to be a CRUD library; it is now a single-value setting */}
          {/* /api/settings.default_ship_name. Route order matters — this MUST */}
          {/* come before the generic /library/:libraryName route below.       */}
          <Route path="/library/ships" element={<ShipSettingsPanel />} />
          <Route path="/library/:libraryName" element={<LibraryPage />} />
          <Route path="*" element={<Navigate to="/voyages" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
    </AccessGate>
  );
}

export default App;
